import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface CarbonInventoryState {
    data: [] | null | any;
    currentPage: number | null;
    totalRecords: number | null;
    totalPages: number | null;
    allCarbonInventory: [] | null | any;
}

const initialState: CarbonInventoryState = {
    data: null,
    totalRecords: null,
    totalPages: null,
    currentPage: null,
    allCarbonInventory: null,
};

export const carbonInventorySlice = createSlice({
    name: 'CarbonInventory',
    initialState,
    reducers: {
        setCarbonInventory: (state, action) => {
            state.data = action.payload.data?.data ? action.payload.data.data : action.payload.data;
            state.totalRecords = action.payload.data?.totalRecords;
            state.totalPages = action.payload.data?.totalPages;
            state.currentPage = action.payload.data?.currentPage;
        },
        setCarbonInventoryBySearch: (state, action) => {
            state.data = action.payload.data?.data ? action.payload.data.data : action.payload.data;
            state.totalRecords = action.payload.data?.totalRecords;
            state.totalPages = action.payload.data?.totalPages;
            state.currentPage = action.payload.data?.currentPage;
        },
        setAllCarbonInventory: (state, action) => {
            state.allCarbonInventory = action.payload.data;
        },
        reset: (state) => {
            Object.assign(state, initialState);
        },
    },
});

export const { setCarbonInventory, setCarbonInventoryBySearch, setAllCarbonInventory, reset } = carbonInventorySlice.actions;
export const getAllCarbonInventoryDetails = (state: RootState) => state.carbonInventory.data;
export const getCarbonInventoryTotalRecords = (state: RootState) => state.carbonInventory.totalRecords;
export const getAllCarbonInventoryBySearch = (state: RootState) => state.carbonInventory.data;
export default carbonInventorySlice.reducer;
